import { render, staticRenderFns } from "./HeaderBar.vue?vue&type=template&id=83057b3e&scoped=true&"
import script from "./HeaderBar.vue?vue&type=script&lang=js&"
export * from "./HeaderBar.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBar.vue?vue&type=style&index=0&id=83057b3e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83057b3e",
  null
  
)

export default component.exports